import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { LazyThreadSafetyMode_NONE_getInstance3htehjw93gc3e as LazyThreadSafetyMode_NONE_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  trim11nh7r46at6sx as trim,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { substringiqarkczpya5m as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharSequence1ju9jr1w86plq as isCharSequence,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HeaderValueClass;
function HeaderValue() {
  if (HeaderValueClass === VOID) {
    class $ {
      constructor(value, params) {
        params = params === VOID ? emptyList() : params;
        this.x4u_1 = value;
        this.y4u_1 = params;
        var tmp = this;
        var tmp0 = this.y4u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (element.o4u_1 === 'q') {
              tmp$ret$0 = element;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        var tmp0_safe_receiver = tmp$ret$0;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p4u_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
        var tmp_0;
        if (tmp2_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) {
            tmp_1 = tmp2_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp3_elvis_lhs = tmp_0;
        tmp.z4u_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
      }
      we() {
        return this.x4u_1;
      }
      toString() {
        return 'HeaderValue(value=' + this.x4u_1 + ', params=' + toString(this.y4u_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.x4u_1);
        result = imul(result, 31) + hashCode(this.y4u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderValue()))
          return false;
        if (!(this.x4u_1 === other.x4u_1))
          return false;
        if (!equals(this.y4u_1, other.y4u_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HeaderValue');
    HeaderValueClass = $;
  }
  return HeaderValueClass;
}
function parseAndSortHeader(header) {
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = parseHeaderValue(header);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = parseAndSortHeader$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
  return sortedWith(this_0, tmp$ret$1);
}
var HeaderValueParamClass;
function HeaderValueParam() {
  if (HeaderValueParamClass === VOID) {
    class $ {
      static e51(name, value, escapeValue) {
        var $this = createThis(this);
        $this.o4u_1 = name;
        $this.p4u_1 = value;
        $this.q4u_1 = escapeValue;
        return $this;
      }
      static y4w(name, value) {
        return this.e51(name, value, false);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof HeaderValueParam()) {
          tmp_0 = equals_0(other.o4u_1, this.o4u_1, true);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.p4u_1, this.p4u_1, true);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = this.o4u_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$0);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = this.p4u_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$2) | 0) | 0;
        return result;
      }
      we() {
        return this.o4u_1;
      }
      xe() {
        return this.p4u_1;
      }
      toString() {
        return 'HeaderValueParam(name=' + this.o4u_1 + ', value=' + this.p4u_1 + ', escapeValue=' + this.q4u_1 + ')';
      }
    }
    initMetadataForClass($, 'HeaderValueParam');
    HeaderValueParamClass = $;
  }
  return HeaderValueParamClass;
}
function parseHeaderValue(text) {
  return parseHeaderValue_0(text, false);
}
function parseHeaderValue_0(text, parametersOnly) {
  if (text == null) {
    return emptyList();
  }
  var position = 0;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var items = lazy(tmp, parseHeaderValue$lambda);
  while (position <= get_lastIndex(text)) {
    position = parseHeaderValueItem(text, position, items, parametersOnly);
  }
  return valueOrEmpty(items);
}
function parseHeaderValueItem(text, start, items, parametersOnly) {
  var position = start;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var parameters = lazy(tmp, parseHeaderValueItem$lambda);
  var valueEnd = parametersOnly ? position : null;
  while (position <= get_lastIndex(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
      var tmp_0 = items.n3();
      var tmp1_elvis_lhs = valueEnd;
      tmp_0.i2(new (HeaderValue())(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
      return position + 1 | 0;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
      if (valueEnd == null)
        valueEnd = position;
      position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
    } else {
      var tmp_1;
      if (parametersOnly) {
        tmp_1 = parseHeaderValueParameter(text, position, parameters);
      } else {
        tmp_1 = position + 1 | 0;
      }
      position = tmp_1;
    }
  }
  var tmp_2 = items.n3();
  var tmp2_elvis_lhs = valueEnd;
  tmp_2.i2(new (HeaderValue())(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
  return position;
}
function valueOrEmpty(_this__u8e3s4) {
  return _this__u8e3s4.jt() ? _this__u8e3s4.n3() : emptyList();
}
function subtrim(_this__u8e3s4, start, end) {
  // Inline function 'kotlin.text.trim' call
  var this_0 = substring(_this__u8e3s4, start, end);
  return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
}
function parseHeaderValueParameter(text, start, parameters) {
  var position = start;
  while (position <= get_lastIndex(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
      var _destruct__k2r9zo = parseHeaderValueParameterValue(text, position + 1 | 0);
      var paramEnd = _destruct__k2r9zo.we();
      var paramValue = _destruct__k2r9zo.xe();
      parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
      return paramEnd;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44)) {
      parseHeaderValueParameter$addParam(parameters, text, start, position, '');
      return position;
    } else {
      position = position + 1 | 0;
    }
  }
  parseHeaderValueParameter$addParam(parameters, text, start, position, '');
  return position;
}
function parseHeaderValueParameterValue(value, start) {
  if (value.length === start) {
    return to(start, '');
  }
  var position = start;
  if (charCodeAt(value, start) === _Char___init__impl__6a9atx(34)) {
    return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
  }
  while (position <= get_lastIndex(value)) {
    var tmp0_subject = charCodeAt(value, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44))
      return to(position, subtrim(value, start, position));
    else {
      position = position + 1 | 0;
    }
  }
  return to(position, subtrim(value, start, position));
}
function parseHeaderValueParameterValueQuoted(value, start) {
  var position = start;
  var builder = StringBuilder().l1();
  loop: while (position <= get_lastIndex(value)) {
    var currentChar = charCodeAt(value, position);
    if (currentChar === _Char___init__impl__6a9atx(34) && nextIsDelimiterOrEnd(value, position)) {
      return to(position + 1 | 0, builder.toString());
    } else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex(value) - 2 | 0)) {
      builder.o1(charCodeAt(value, position + 1 | 0));
      position = position + 2 | 0;
      continue loop;
    }
    builder.o1(currentChar);
    position = position + 1 | 0;
  }
  var tmp = position;
  var tmp0 = _Char___init__impl__6a9atx(34);
  // Inline function 'kotlin.text.plus' call
  var other = builder.toString();
  var tmp$ret$0 = toString_0(tmp0) + other;
  return to(tmp, tmp$ret$0);
}
function nextIsDelimiterOrEnd(_this__u8e3s4, start) {
  var position = start + 1 | 0;
  loop: while (position < _this__u8e3s4.length && charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32)) {
    position = position + 1 | 0;
  }
  return position === _this__u8e3s4.length || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59) || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(44);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.f51_1 = function_0;
      }
      eh(a, b) {
        return this.f51_1(a, b);
      }
      compare(a, b) {
        return this.eh(a, b);
      }
      i5() {
        return this.f51_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function parseAndSortHeader$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.z4u_1;
  var tmp$ret$2 = a.z4u_1;
  return compareValues(tmp, tmp$ret$2);
}
function parseHeaderValue$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList().p2();
}
function parseHeaderValueItem$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList().p2();
}
function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
  var name = subtrim(text, start, end);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(name) === 0) {
    return Unit_instance;
  }
  $parameters.n3().i2(HeaderValueParam().y4w(name, value));
}
//region block: exports
export {
  HeaderValueParam as HeaderValueParam1kbqez3tb3lqp,
  parseAndSortHeader as parseAndSortHeader33xgq5fx7y6j1,
  parseHeaderValue as parseHeaderValuealpos28fgp6t,
};
//endregion

//# sourceMappingURL=HttpHeaderValueParser.mjs.map
